import React from "react";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import VillaMap from "./VillaMap";

const MAP_URL =
  "https://www.google.com/maps/search/?api=1&query=31.300988,-7.724062";

const LocationSection = () => {
  const { t } = useTranslation();

  return (
    <section className="bg-cream overflow-hidden">
      <div className="grid lg:grid-cols-2 items-stretch">
        {/* Text */}
        <motion.div
          className="flex items-center px-5 md:px-10 lg:px-16 py-20 md:py-28"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.8 }}
        >
          <div className="max-w-lg lg:ml-auto">
            <span className="eyebrow text-brass block mb-5">
              {t("labels.location")}
            </span>
            <h2 className="font-serif font-light text-4xl md:text-5xl text-ink leading-tight">
              {t("location.title")}
            </h2>
            <div className="rule-gold my-7" />
            <p className="text-base md:text-lg text-ink-soft leading-relaxed font-light mb-8">
              {t("location.description")}
            </p>
            <p className="flex items-start gap-3 text-ink-soft mb-10">
              <span className="text-brass mt-1">◆</span>
              <span>77XG+WV7 Taljerft, Ourika 42452, Morocco</span>
            </p>
            <a
              href={MAP_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-3 border border-ink/30 text-ink hover:bg-ink hover:text-cream text-[12px] uppercase tracking-[0.22em] py-4 px-10 transition-all duration-300"
            >
              {t("location.viewOnMap")}
              <svg
                className="w-4 h-4"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={1.5}
                  d="M14 5l7 7m0 0l-7 7m7-7H3"
                />
              </svg>
            </a>
          </div>
        </motion.div>

        {/* Interactive map */}
        <motion.div
          className="min-h-[320px] lg:min-h-[560px] bg-cream-dark"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 1 }}
        >
          <VillaMap />
        </motion.div>
      </div>
    </section>
  );
};

export default LocationSection;
